import { useQuery } from '@tanstack/react-query'
import { useAppTranslation } from '../../../hooks/useAppTranslation'
import { notificationsQueries } from '../../../api/notifications'
import { useAuth } from '../../../hooks/useAuth'
import { ActiveTabBar } from '../../../views/chat'
import { i18nSocietyType } from '../../../i18n'
import { useCurrentSociety } from '../../../hooks/useCurrentSociety'

interface GetTabsReturnType {
  getTabs: () => { title: string; displayNotificationBadge: boolean }[]
}

export const useTabBarOptions = (
  activeTabBar: ActiveTabBar
): GetTabsReturnType => {
  const { userId } = useAuth()
  const { data } = useQuery(
    notificationsQueries.getUserUnseenUnreadCount(userId)
  )
  const { translate } = useAppTranslation()
  const { society } = useCurrentSociety()

  const oneOnOneCount = data?.unseen.oneOnOneCount || 0
  const interestsCount = data?.unseen.interestsCount || 0
  const boardCount = data?.unseen.boardCount || 0

  const getTabs = (): {
    title: string
    displayNotificationBadge: boolean
  }[] => {
    if (activeTabBar === ActiveTabBar.RESIDENT) {
      return [
        {
          title: translate('chatRoomsSidebar.tabs.oneOnOneTitle'),
          displayNotificationBadge: oneOnOneCount > 0,
        },
        {
          title: translate('chatRoomsSidebar.tabs.InterestsTitle'),
          displayNotificationBadge: interestsCount > 0,
        },
      ]
    }
    return [
      {
        title: translate('chatRoomsSidebar.tabs.boardTitle', {
          context: i18nSocietyType(society?.societyTypeDisplayName),
        }),
        displayNotificationBadge: boardCount > 0,
      },
    ]
  }

  return { getTabs }
}
